import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 felt-texture" data-id="element-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-14">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-15">
            Ready to <span className="text-[#00ff88]" data-id="element-16">Beat the House?</span>
          </h2>
          <p className="text-gray-400 text-lg mb-12 max-w-2xl mx-auto" data-id="element-17">
            Let's discuss how we can transform your sports betting affiliate
            program into a revenue powerhouse. Get your free performance audit
            today.
          </p>

          <div className="bg-[#0d2818]/60 border border-[#00ff88]/20 rounded-lg p-8 mb-8" data-id="element-18">
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-6 sm:space-y-0 sm:space-x-12" data-id="element-19">
              <div className="flex items-center space-x-3" data-id="element-20">
                <Mail className="text-[#00ff88]" size={24} data-id="element-21" />
                <a href="mailto:contact@steelserieshub.com" className="text-lg hover:text-[#00ff88] transition-colors" data-id="element-22">
                  contact@steelserieshub.com
                </a>
              </div>
              <div className="flex items-center space-x-3" data-id="element-23">
                <MapPin className="text-[#00ff88]" size={24} data-id="element-24" />
                <span className="text-lg text-gray-300" data-id="element-25">Limassol, Cyprus</span>
              </div>
            </div>
          </div>

          <motion.a href="mailto:contact@steelserieshub.com" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-[#00ff88] text-[#0a1a0f] px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#22c55e] transition-colors glow-green" data-id="element-26">
            Request Free Audit
          </motion.a>
        </motion.div>
      </div>
    </section>;
}